import bcrypt from 'bcryptjs';

// Şifre hashleme fonksiyonu
export const hashPassword = async (password) => {
  try {
    const salt = await bcrypt.genSalt(10);
    return await bcrypt.hash(password, salt);
  } catch (error) {
    console.error('Şifre hashleme hatası:', error);
    throw error;
  }
};

// Şifre karşılaştırma fonksiyonu 
export const comparePassword = async (plainPassword, hashedPassword) => {
  try {
    // Null/undefined kontrolü ekleyelim
    if (!plainPassword || !hashedPassword) {
      return false;
    }
    return await bcrypt.compare(plainPassword, hashedPassword);
  } catch (error) {
    console.error('Şifre karşılaştırma hatası:', error);
    return false;
  }
}; 